import { reactive } from 'vue';
import { createInjection } from 'src/lib/createInjection';

type FullScreenSpinnerContext = {
  show: boolean;
  message: string;
  isHtmlMessage: boolean;
  notifyShow: (opts: { message: string; isHtmlMessage: boolean }) => void;
  notifyHide: () => void;
};

const { provide, inject } = createInjection<FullScreenSpinnerContext>('useFullScreenSpinner');

export function provideFullScreenSpinner(): void {
  const spinner = reactive<FullScreenSpinnerContext>({
    show: false,
    message: '',
    isHtmlMessage: false,
    notifyShow({ message, isHtmlMessage }) {
      spinner.show = true;
      spinner.message = message;
      spinner.isHtmlMessage = isHtmlMessage;
    },
    notifyHide() {
      spinner.show = false;
      spinner.message = '';
      spinner.isHtmlMessage = false;
    },
  });

  provide(spinner);
}

export function useFullScreenSpinner(): FullScreenSpinnerContext {
  return inject();
}
